<template>
  <div id="footer">
    <div class="about_wrap">
      <div class="about">
        <a target="_blank" v-for="item in linkList" :key="item.itemDesc" :href="item.itemDesc">
          <div class="footer_link">{{item.itemValue}}</div>
        </a>
      </div>
    </div>
    <div class="footer1">
      <div class="navs">
        <div class="nav">主办单位：浙江省市场监督管理局（知识产权局）</div>
        <span>|</span>
        <div class="nav">{{ tel1 }}</div>
      </div>
      <div class="navs">
        <div class="nav">{{ tel2 }}</div>
        <span>|</span>
        <div class="nav">{{ tel3 }}</div>
      </div>
      <div class="navs">
        <div class="nav">
          <a class="point" href="http://beian.miit.gov.cn" target="_blank">备案序号 浙ICP备 19046660号</a>
        </div>
        <span>|</span>
        <div class="nav">网站标识码：3300000136</div>
        <span>|</span>
        <div class="nav">
          <a
            class="point"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602010565"
            target="_blank"
          >浙公网安备 33010602010565号</a>
        </div>
      </div>
      <div class="cop_success">建议使用1366*768分辨率/Edge、Chrome等现代浏览器访问达到最佳效果</div>
      <div class="cop_jiucuo">
        <span id="_ideConac">
          <a
            href="//bszs.conac.cn/sitename?method=show&amp;id=0584797714CF085DE053012819ACF7C7"
            target="_blank"
          >
            <img
              src="//zjjcmspublic.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/jcms_files/jcms1/web1/site/script/zjzwfw-2019/red.png"
            />
          </a>
        </span>
        <span id="_span_jiucuo">
          <img
            @click="Link('3300000136')"
            style="margin:0;border:0;cursor: pointer;"
            src="https://zfwzgl.www.gov.cn/exposure/images/jiucuo.png?v=3300000136"
          />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { bottomLinks, bottomNav } from "@/api/index";
export default {
  data() {
    return {
      linkList: [],
      tel1: "",
      tel2: "",
      tel3: ""
    };
  },
  created() {
    bottomLinks().then(res => {
      this.linkList = res.data;
    });
    bottomNav().then(res => {
      this.tel1 = res.data.filter(
        e => e.itemCode == "OTHING_BASIC_KSSC_TEL"
      )[0].itemDesc;
      this.tel2 = res.data.filter(
        e => e.itemCode == "OTHING_BASIC_YXSC_TEL"
      )[0].itemDesc;
      this.tel3 = res.data.filter(
        e => e.itemCode == "OTHING_BASIC_TEL"
      )[0].itemDesc;
    });
  },
  methods: {
    Link(site_code) {
      let url = location.href;
      url = decodeURIComponent(url);
      url = encodeURIComponent(url).replace(/%257B/g, "%7B");
      url = url.replace(/%257D/g, "%7D");
      window.open(
        `https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=${site_code}&url=${url}`
      );
    }
  }
};
</script>
<style scoped lang="less">
#footer {
  width: 100%;
  background-color: #3f93f6;
}
.footer1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  // align-items: center;
  color: #fff;
  padding: 20px 0;
  // height: 120px;
  // line-height: 120px;
}
.about_wrap {
  width: 100%;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  min-height: 100px;
}
.about {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.footer_link {
  color: #fff;
  padding: 4.5px 25px;
  background: rgba(255, 255, 255, 0.2);
  margin: 10px 0;
}
.navs {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

  .nav {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }
  span {
    margin: 0 16px;
    color: #a6c6de;
    font-size: 14px;
    line-height: 30px;
  }
  .point {
    color: #fff;
  }
}
.cop_success {
  color: #b1cee7;
  width: 100%;
  text-align: center;
}
.cop_jiucuo {
  margin-top: 6px;
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  #_span_jiucuo {
    margin-left: 6px;
  }
}
</style>